import React from 'react';
import classNames from 'classnames';
import { ChevronDown } from 'react-feather';

import { Text, TEXT_VARIANTS } from 'ui/Typography';

const LessonHeaderSectionButton = ({
  className,
  onClick,
  currentSectionIndex,
  totalSectionCount,
  hovered,
  ...buttonProps
}) => {
  const buttonClassName = classNames('LessonHeaderSectionButton', className, {
    'LessonHeaderSectionButton--hovered': hovered,
  });

  // If we are not passed a section we assume we are the on /complete page
  // which shows the section button with section to the totalSectionCount
  const sectionIndex = currentSectionIndex || totalSectionCount;

  return (
    <button
      type="button"
      onClick={onClick}
      className={buttonClassName}
      aria-labelledby="lesson-table-of-contents"
      {...buttonProps}
    >
      <Text className="d-f ai-c" variant={TEXT_VARIANTS.BODY_LIGHT}>
        {`${t('lessons.section')} ${sectionIndex} / ${totalSectionCount}`}
        <ChevronDown size="1.25rem" className="ml-4" />
      </Text>
    </button>
  );
};

export default LessonHeaderSectionButton;
